import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const InventoryTransferDetailPage = () => {
  const { transferId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to create page with transferId parameter for editing
    if (transferId) {
      navigate(`/inventory-transfer/create/${transferId}`, { replace: true });
    } else {
      // If no transferId, redirect to create new transfer
      navigate('/inventory-transfer/create', { replace: true });
    }
  }, [transferId, navigate]);

  return null; // This component only handles redirection
};

export default InventoryTransferDetailPage;
